<template>
    <div class="page-block__item-wrapper page-block__item-wrapper-whois">
        <h3>{{ trans('domain.whois-title') }}</h3>
        <div class="page-block__item" v-if="!whoisData.is_private">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                        <span class="page-block__item-content-title">
                            {{ trans('domain.whois.edit-data') }}
                        </span>
                    </div>
                    <!--
                 -->
                    <div
                        v-if="whoisData && whoisData.owner && whoisData.owner.last_name"
                        class="layout__item u-2/3-desk"
                    >
                        <span>{{ whoisData.owner.first_name }} {{ whoisData.owner.last_name }}</span>
                        <span v-if="whoisData.owner.organization"> ({{ whoisData.owner.organization }})</span>
                    </div>
                    <div v-else class="layout__item u-2/3-desk">
                        <div class="loader loader--small">
                            <span class="loader__ring loader__ring--small"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-block__item-nav | u-align-self-start" v-if="canEdit">
                <customer-router-link :to="{ name: 'whoisOverview' }">
                    <button dusk="whois-edit-button" type="button" class="btn btn--ghost btn--ghost-full-width">
                        {{ trans('domain.whois.edit-data-button') }}
                    </button>
                </customer-router-link>
            </div>
        </div>

        <domain-private-whois
            :whoisData="whoisData"
            :domain="subscription.domain"
            :subscription="subscription"
        />
    </div>
</template>

<script>
import { productMixin } from 'relapp-register';
import parseDomain from 'parse-domain';
import DomainPrivateWhois from './DomainPrivateWhois.vue';

export default {
    mixins: [productMixin],
    components: {
        DomainPrivateWhois
    },
    props: {
        whoisData: {
            type: Object,
            default: null
        },
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    computed: {
        /**
         * Returns a property used by productMixin to get the product data.
         *
         * @returns {{domain: string, name: string, type: string}}
         */
        productPlan() {
            return {
                domain: this.domain,
                name: '.' + parseDomain(this.domain).tld,
                type: 'extension'
            };
        },
        /**
         * Returns true if the whois data can be edited.
         *
         * @returns {boolean}
         */
        canEdit() {
            let product = this.product;

            if (!product) {
                return false;
            }

            return product.descriptors.small['product-spec.domain.allow_whois'];
        }
    }
};
</script>
